import Box from '@mui/material/Box';
import Body from '../components/Collaborator/Body';
import '../components/Collaborator/Collaborator.css';

const CollaboratorScreen = () => {
    return (
        <Box boxShadow={0}>
            <Body />
        </Box>
    );
}

export default CollaboratorScreen;